import { useCheckOverflow, useGetDimension } from '@shared/hooks';
import { useRef } from 'react';

import { Text, type TextProps } from '../text';
import { Tooltip, type TooltipProps } from '../tooltip';
import { mergeSx } from '../utils';

export interface EllipsisTextProps extends TextProps {
  maxLines?: number;
  slotProps?: {
    tooltip?: TooltipProps;
  };
}

export default function EllipsisText(props: Readonly<EllipsisTextProps>) {
  const {
    maxLines = 1,
    sx,
    children,
    slotProps: { tooltip: tooltipProps } = {},
    ...restProps
  } = props;
  const textRef = useRef<HTMLElement>(null);
  const shouldShowTooltip = useCheckOverflow(textRef);
  const {
    width: { offset: tooltipWidth },
  } = useGetDimension(textRef);

  return (
    <Tooltip
      title={shouldShowTooltip ? (children as string) : ''}
      maxWidth={tooltipWidth}
      {...tooltipProps}
    >
      <Text
        ref={textRef}
        sx={mergeSx(
          {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: maxLines.toString(),
            WebkitBoxOrient: 'vertical',
          },
          sx,
        )}
        {...restProps}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
